import { Link } from "wouter";

export function AppFooter() {
  return (
    <footer className="border-t mt-8 sm:mt-16">
      <div className="max-w-6xl mx-auto px-2 sm:px-4 py-4 sm:py-6 text-xs sm:text-sm text-muted-foreground space-y-4">
        <p className="text-center">
          DanceMirror helps dancers learn dance moves faster with mirrored videos, playback control, and clear left/right guidance.
        </p>
        <nav className="flex items-center justify-center gap-4 sm:gap-6">
          <Link href="/terms" className="hover:text-foreground transition-colors" data-testid="link-terms">
            Terms
          </Link>
          <Link href="/privacy" className="hover:text-foreground transition-colors" data-testid="link-privacy">
            Privacy
          </Link>
          <a href="mailto:support@payong.io?subject=DanceMirror%20Support" className="hover:text-foreground transition-colors" data-testid="link-support">
            Support
          </a>
        </nav>
        <p className="text-center text-muted-foreground/70">
          &copy; {new Date().getFullYear()} DanceMirror by{" "}
          <a href="https://payong.io" target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition-colors">
            payong.io
          </a>
          . All rights reserved.
        </p>
      </div>
    </footer>
  );
}
